export { default as OpenConstructionCostSlot } from './OpenConstructionCostSlot';
